import React, { useEffect } from 'react';
// import { useSignals } from '@preact/signals-react/runtime';
import jsonData from '../../signals/jsonData';
import setLanguage from '../../hooks/setLanguage';
import translation from '../../signals/translations';
import IconHeartFilled from '../../icons/IconHeartFilled';
import appState from '../../signals/appState';

const ExhibitorListPrint = ({ onPrintReady }) => {
	// useSignals();

	const { exhibitorInfo } = jsonData.value;

	const urlParams = new URLSearchParams(window.location.search);
	const orientation = urlParams.get('orientation');

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const lang = params.get('lang');
		if (lang) setLanguage(lang);
	}, []);

	useEffect(() => {
		if (!appState.value.loading) {
			const waitForPaint = async () => {
				if (document.fonts?.ready) {
					try {
						await document.fonts.ready;
					} catch {
						// ignore font readiness failures
					}
				}
				await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
				onPrintReady?.();
			};

			waitForPaint();
		}
	}, [onPrintReady, exhibitorInfo.length]);

	return (
		<div id='ExhibitorListPrint' className={orientation === 'landscape' ? 'landscape' : ''}>
			<div className='panel-heading'>{translation('print.exhibitorList')}</div>
			<div className='panel-body'>
				<div className='exhibitors'>
					<div className='exhibitor'>
						<div className='name heading'>{translation('print.exhibitorName')}</div>
						<div className='booth-number heading'>{translation('print.boothNumber')}</div>
						<div className='favourite heading'>{translation('print.favorite')}</div>
					</div>

					{exhibitorInfo.map((exhibitor, index) => {
						const exhibitorName = exhibitor['廠商名稱'];
						const booth = exhibitor['攤位號碼'];
						const isFav = exhibitor.favourite;

						return (
							<div className='exhibitor' key={`exhibitorLinkTableRow${index}`}>
								<div className='name'>{exhibitorName}</div>
								<div className='booth-number'>{booth}</div>
								<div className='favourite'>{isFav ? <IconHeartFilled /> : null}</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default ExhibitorListPrint;
